export class Resources {
  static readonly dashboardV2 = 'dashboard-v2';
  static readonly dashboardV3 = 'dashboard-v3';
  static readonly user = 'player';
  static readonly userInfo = 'user-management/user-info';
  static readonly referralRanking = 'user-management/referral-ranking';
  static readonly userFeedback = 'user-management/user-feedback';
  static readonly userStatistics = 'player/statistics';
  static readonly agency = 'agency';
  static readonly currency = 'currency';
  static readonly game = 'game';
  static readonly gameCategory = 'game/category';
  static readonly gameDetail = 'game-detail';
  static readonly gameRule = 'game-rule';
  static readonly gameDocument = 'game-document';
  static readonly staticConfig = 'static-config';
  static readonly transaction = 'transaction';
  static readonly setting = 'setting';
  static readonly gameStatistics = 'game/statistics';
  static readonly users = 'users';
  static readonly roles = 'roles';
  static readonly groups = 'groups';
  static readonly userRole = 'user-role';
  static readonly tokenMetadata = 'token/metadatas';
  static readonly tokenOnchainInfo = 'token/onchain-infos';
  static readonly tokenXstock = 'token/x-stocks';
  static readonly feeManagement = 'trading/fee-management';
  static readonly systemRpc = 'system/rpc';
  static readonly systemRpc_v2 = 'system/rpc_v2';
  static readonly systemProxy = 'system/proxy';
  static readonly proxyManager = 'proxy-manager';
  static readonly proxyManagerProxies = 'proxy-manager/proxies';
  static readonly proxyManagerPools = 'proxy-manager/pools';
  static readonly proxyManagerProxyScores = 'proxy-manager/proxy-scores';
  static readonly crawlerMonitor = 'system/crawler-monitor';
  static readonly cronMonitor = 'system/cron-monitor';
  static readonly categories = 'home/categories';
  static readonly smartMoney = 'smart-money';
  static readonly trandingToken = 'configs/tranding-tokens';
  static readonly searchPlaceholder = 'configs/search-placeholders';
  static readonly color = 'configs/colors';
  static readonly transactions = 'transactions';
  static readonly adminConfig = 'configs/admin-configs';
  static readonly swapTransaction = 'swap/transaction';
  static readonly transactionDashboard = 'swap-transactions/dashboard';
  static readonly routingStatistics = 'swap-transactions/routing-statistics';
  static readonly tokenRouteStatistics = 'swap-transactions/token-route-statistics';
  static readonly swapUser = 'swap/user';
  static readonly swapUserRanking = 'swap-users/ranking';
  static readonly swapUserDetail = 'swap-users/detail';
  static readonly swapChainsManagement = 'swap-chain-token/chains-management';
  static readonly swapTokensManagement = 'swap-chain-token/tokens-management';
  static readonly swapConfigFee = 'swap-config/fee';
  static readonly swapConfigRango = 'swap-config/rango';
  static readonly activityUserActivityStats = 'activity/userActivityStats';
  static readonly activityUsers = 'activity/users';
  static readonly activityUserCashbackDashboard = 'activity/userCashbackDashboard';
  static readonly activityUserActivityCashbackSummary = 'activity/userActivityCashbackSummary';
  static readonly activityUsertaskCenter = 'activity/usertaskCenter';
  static readonly activityUserTaskCompletionHistory = 'activity/userTaskCompletionHistory';
  static readonly activityTasks = 'activity/tasks';
  static readonly activityTaskCompletionStats = 'activity/taskCompletionStats';
  static readonly activityTaskCategories = 'activity/taskCategories';
  static readonly activityTierBenefits = 'activity/tierBenefits';
  static readonly activityTierBenefitDistribution = 'activity/tierDistribution';
  static readonly agents = 'agents';
  static readonly unlimitedAgents = 'unlimited-agents';
  static readonly rewardsOverview = 'rewards-overview';
  static readonly rewardsTask = 'rewards-task';
  static readonly agentInfo = 'agent-info';
  static readonly rewardClaims = 'agent-reward-claims';
  static readonly maintenance = 'system/maintenance';
  static readonly withdraw = 'finance/withdraw';
  static readonly sign = 'finance/sign';
  static readonly financeTransfers = 'finance/transfers';
  static readonly financeAllowlist = 'finance/allowlist';
  static readonly financeLimits = 'finance/limits';
  static readonly tunkeySetups = 'finance/turnkey-config';
  static readonly inviteCodes = 'invite-codes';
  static readonly inviteBetaCodeConfig = 'invite-beta-code-config';
  static readonly banners = 'banners';
  static readonly smallBanners = 'small-banners';
  static readonly hotSearch = 'hotSearching';
  static readonly hotSymbols = 'hot-symbols';
  static readonly relayDeposit = 'relay';
  static readonly auditLogs = 'audit-logs';
  static readonly analytics = 'analytics';
  static readonly appVersionManagement = 'app-version-management';
  static readonly domainConfigs = 'domain-configs';
  static readonly healthCheckProxy = 'domain-configs/health-check-proxy';
  static readonly announcementPopup = 'publishing/announcement-popup';
  static readonly linkConfig = 'publishing/link-configs';
  static readonly cdnUpload = 'publishing/cdn-uploads';
  static readonly coinImages = 'cdn/coin-images';
  static readonly coinSymbols = 'cdn/coin-symbols';
  static readonly redpacket = 'redpacket';
  static readonly redpacketTypeConfig = 'redpacket/type-config';
  static readonly redpacketOverview = 'redpacket/overview';
  static readonly redpacketIntervention = 'redpacket/intervention';
  static readonly redpacketredPacketConfig = 'redpacket/redPacketConfig';
  static readonly redpacketRecords = 'redpacket/records';
  static readonly redpacketLottoDrawConfigs = 'redpacket/lotto-draw-configs';
  static readonly redpacketDesignatedRedPackets = 'redpacket/designated-redpackets';
  static readonly redpacketLeaderboardCycles = 'redpacket/leaderboard-cycles';
  static readonly redpacketDailyPrizePool = 'redpacket/daily-prize-pool';
  static readonly redpacketDailyPrizePoolStatus = 'redpacket/daily-prize-pool-status';
  static readonly redpacketDailyPrizePoolConfigAudit = 'redpacket/daily-prize-pool-config-audit';
  static readonly redpacketFeatureFlags = 'redpacket/feature-flags';
  static readonly redpacketCampaignDates = 'redpacket/campaign-dates';
  static readonly redpacketRewardPoolBalances = 'redpacket/reward-pool-balances';
  static readonly redpacketOverlay = 'redpacket/overlay';
  static readonly redpacketLuckyLottoHistory = 'redpacket/lucky-lotto-history';
  static readonly predictionConfigs = 'prediction/system-configs';
  static readonly predictionFeaturedMarkets = 'prediction/admin-events/custom-breaking';
  static readonly predictionFeaturedMarketsMarkets = 'prediction/admin-events/markets';
  static readonly predictionFeaturedMarketsEvents = 'prediction/admin-events';
  static readonly predictionTrading = 'prediction-trading';
  static readonly perpetualTrading = 'perpetual-trading';
  static readonly tradingRetention = 'user-management/trading-retention';
  static readonly agentRewardRules = 'agent-reward-rules';
  static readonly xbitRelayHotWallets = 'xbit-relay/hot-wallets';
  static readonly xbitRelayDeposits = 'xbit-relay/deposits';
  static readonly xbitRelayWithdrawals = 'xbit-relay/withdrawals';
  static readonly xbitRelayTransfers = 'xbit-relay/transfers';
  static readonly xbitRelaySweepMonitor = 'xbit-relay/sweep-monitor';
  static readonly xbitRelaySweepHistory = 'xbit-relay/sweep-history';
  static readonly xbitRelayDepositWallets = 'xbit-relay/deposit-wallets';
  static readonly xbitRelayWithdrawalProviderConfigs = 'xbit-relay/withdrawal-provider-configs';
  static readonly xbitRelayTransactionRescan = 'xbit-relay/transaction-rescan';
  static readonly xbitRelayHotWalletBalancer = 'xbit-relay/hot-wallet-balancer';
  static readonly xbitRelayProviderAudit = 'xbit-relay/provider-audit';
  static readonly xpxPerpsWithdrawal = 'xpx-perps/withdrawal';
  static readonly xpxPerpsChainConfigs = 'xpx-perps/chain-token-config/chains';
  static readonly xpxPerpsTokenConfigs = 'xpx-perps/chain-token-config/tokens';
  static readonly perpsV1Views = 'perps-v1/views';
  static readonly perpsV1Pins = 'perps-v1/pins';
  static readonly perpsV1Sectors = 'perps-v1/sectors';
  static readonly perpsV1Symbols = 'perps-v1/symbols';
  static readonly perpsV1Presets = 'perps-v1/favorite-presets';
  static readonly whitelistCandidate = 'whitelist/candidate'
  static readonly whitelistReward = 'whitelist/reward'
  static readonly whitelistFaq = 'whitelist/faq'
  static readonly whitelistEarlyBird = 'whitelist/early-bird'
  static readonly whitelistLeaderboard = 'whitelist/leaderboard'
  static readonly whitelistInvite = 'whitelist/invite'
  static readonly whitelistManually = 'whitelist/manually'
  static readonly whitelistRedeem = 'whitelist/redeem'
  static readonly whitelistUsers = 'whitelist/users'
  static readonly whitelistEventParticipants = 'whitelist/event-participants'
  static readonly blindBoxOverview = 'blindBox/overview';
  static readonly blindBoxActivityBasic = 'blindBox/activity-basic';
  static readonly blindBoxLuckyWheel = 'blindBox/lucky-wheel';
  static readonly blindBoxBlindBoxProbability = 'blindBox/blind-box-probability';
  static readonly blindBoxTradingTiers = 'blindBox/trading-tiers';
  static readonly blindBoxManualDistribution = 'blindBox/manual-distribution';
  static readonly blindBoxLeaderboard = 'blindBox/leaderboard';
  static readonly blindBoxLevelSystem = 'blindBox/level-system';
  static readonly blindBoxLevelProbabilities = 'blindBox/level-probabilities';
  static readonly blindBoxHolidayLottery = 'blindBox/holiday-lottery';
  static readonly blindBoxHolidayLotteryConfig = 'blindBox/holiday-lottery-config';
  static readonly blindBoxTasks = 'blindBox/tasks';
  static readonly blindBoxWinnersTicker = 'blindBox/winners-ticker';
  static readonly blindBoxWinRecords = 'blindBox/win-records';
  static readonly blindBoxOpenSessions = 'blindBox/open-sessions';
  static readonly blindBoxTaskClaims = 'blindBox/task-claims';
  static readonly blindBoxLotteryTickets = 'blindBox/lottery-tickets';
  static readonly blindBoxUserXpHistory = 'blindBox/user-xp-history';
  static readonly blindBoxSpinBoxGrantHistory = 'blindBox/spin-box-grant-history';
  static readonly blindBoxUserRewardSummary = 'blindBox/user-reward-summary';
  static readonly blindBoxRewardFeed = 'blindBox/reward-feed';
  static readonly blindBoxRewardFeedUsdc = 'blindBox/reward-feed-usdc';
  static readonly blindBoxSocialFollowers = 'blindBox/social-followers';
  static readonly blindBoxWithdrawConfig = 'blindBox/withdraw-config';
  static readonly blindBoxWithdrawals = 'blindBox/withdrawals';
  static readonly blindBoxBannedUsers = 'blindBox/banned-users';
  static readonly vaultDashboard = 'vault/dashboard';
  static readonly vaultParams = 'vault/params';
  static readonly vaultOfficialVaults = 'vault/official-vaults';
  static readonly vaultVaults = 'vault/vaults';
  static readonly vaultInvestors = 'vault/investors';
  static readonly vaultRecords = 'vault/records';
  static readonly vaultReconciliation = 'vault/reconciliation';
  static readonly vaultOperations = 'vault/operations';
  static readonly worldCupOverview = 'world-cup/overview';
  static readonly worldCupMatchData = 'world-cup/match-data';
  static readonly worldCupFocusMatchConfig = 'world-cup/focus-match-config';
  static readonly worldCupGrandPrixConfig = 'world-cup/grand-prix-config';
  static readonly worldCupLeaderboardConfig = 'world-cup/leaderboard-config';
  static readonly worldCupPredictionVoucherRule = 'world-cup/prediction-voucher-rule';
  static readonly worldCupEmergencyFuse = 'world-cup/emergency-fuse';
  static readonly worldCupFaq = 'world-cup/faq';
  static readonly worldCupManualIssue = 'world-cup/voucher-manual-issue';
  static readonly worldCupUserVouchers = 'world-cup/user-vouchers';
  static readonly worldCupWhitelist = 'world-cup/whitelist';
  static readonly worldCupBreakingEvents = 'world-cup/custom-breaking';
  static readonly worldCupBreakingEventsEvents = 'world-cup/custom-breaking/events';
  static readonly turnkeyAddressSearch = 'turnkey-address-search';
  static readonly boldPredictionCampaignConfigs = 'bold-prediction-campaign/configs'
  static readonly boldPredictionCampaignStatistics = 'bold-prediction-campaign/statistics'
  static readonly notificationConfigs = 'notification-configs'
  static readonly notificationConfigsTemplates = 'notification-configs/templates'
  static readonly notificationConfigsRecords = 'notification-configs/records'
  static readonly socialTradingWorkbench = 'social-trading/workbench';
  static readonly socialTradingWorkbenchTodos = 'social-trading/workbench-todos';
  static readonly socialTradingAccounts = 'social-trading/accounts';
  static readonly socialTradingUsers = 'social-trading/users';
  static readonly socialTradingAgents = 'social-trading/agents';
  static readonly socialTradingRooms = 'social-trading/rooms';
  static readonly socialTradingRoomMembers = 'social-trading/room-members';
  static readonly socialTradingSignals = 'social-trading/signals';
  static readonly socialTradingIntel = 'social-trading/intel';
  static readonly socialTradingIntelCategories = 'social-trading/intel-categories';
  static readonly socialTradingRedpacketLedger = 'social-trading/redpacket-ledger';
  static readonly socialTradingRedpacketConfig = 'social-trading/redpacket-config';
  static readonly socialTradingRedpacketPackets = 'social-trading/redpacket-packets';
  static readonly socialTradingRedpacketLedgerEntries = 'social-trading/redpacket-ledger-entries';
  static readonly socialTradingRedpacketWithdrawals = 'social-trading/redpacket-withdrawals';
  static readonly socialTradingRedpacketBalanceReclaim = 'social-trading/redpacket-balance-reclaim';
  static readonly socialTradingRedpacketPlatformLedger = 'social-trading/redpacket-platform-ledger';
  static readonly socialTradingSystemConfigs = 'social-trading/system-configs';
  static readonly socialTradingAvatarDefaults = 'social-trading/avatar-defaults';
  static readonly socialTradingRedpacketDisplayRules = 'social-trading/redpacket-display-rules';
  static readonly socialTradingPoolConfig = 'social-trading/pool-config';
  static readonly socialTradingAgentsConfig = 'social-trading/agentsConfig';
  static readonly socialTradingPools = 'social-trading/pools';
  static readonly socialTradingPoolDashboard = 'social-trading/pool-dashboard';
  static readonly socialTradingPoolEnrollments = 'social-trading/pool-enrollments';
  static readonly socialTradingPoolContributions = 'social-trading/pool-contributions';
  static readonly socialTradingPoolRewardClaims = 'social-trading/pool-reward-claims';
  static readonly socialTradingSettlementCycles = 'social-trading/settlement-cycles';
  static readonly socialTradingMessageStats = 'social-trading/message-stats';
  static readonly socialTradingAudit = 'social-trading/audit';
}
